import ApolloClient from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { WebSocketLink } from "apollo-link-ws";
import { split } from "apollo-link";
import { HttpLink } from "apollo-link-http";
import { getMainDefinition } from "apollo-utilities";
import fetch from 'node-fetch';


const headers = {'content-type': 'application/json'};
const getHeaders = () => {
  return headers;
};

const endpoint = process.env.GRAPHQL_ENDPOINT;

const cache = new InMemoryCache();

const wsLink = process.browser ? new WebSocketLink({
  uri: `wss://${endpoint}`,
  options: {
    reconnect: true,
    lazy: true,
    connectionParams: () => {
      return { headers: getHeaders() };
    },
  },
}): null;

const httpLink = new HttpLink({
  uri: `https://${endpoint}`,
  headers: getHeaders(),
  fetch: fetch
});

const link = process.browser ? split(
  ({ query }) => {
    const { kind, operation } = getMainDefinition(query);
    return kind === "OperationDefinition" && operation === "subscription";
  },
  wsLink,
  httpLink
) : httpLink;

export const client = new ApolloClient({
  link,
  cache
});

export function createApolloClient(authToken = false){

  let headers = {'content-type': 'application/json'};
  if(authToken){
    headers['Authorization'] = `Bearer ${authToken}`;
  }
    
    const cache = new InMemoryCache();

      const wsLink = process.browser ? new WebSocketLink({
        uri: `wss://${endpoint}`,
        options: {
          reconnect: true,
          lazy: true,
          connectionParams: () => {
            return { headers: getHeaders() };
          },
        },
      }): null;

      const httpLink = new HttpLink({
        uri: `https://${endpoint}`,
        headers: headers,
        fetch: fetch
    });

      const link = process.browser ? split(
        ({ query }) => {
          const { kind, operation } = getMainDefinition(query);
          return kind === "OperationDefinition" && operation === "subscription";
        },
        wsLink,
        httpLink
      ) : httpLink;

      const client = new ApolloClient({
        link,
        cache,
      });
      return client;
}